module.exports = __webpack_public_path__ + "static/media/logo192.977b2624.png";